import { Text } from '@leroy-merlin-br/backyard-react'

import { AlertMessage } from 'shared/components/AlertMessage'

const CancelledAfterInaccessiblePlace = () => (
  <AlertMessage type="critical">
    Seu pedido foi{' '}
    <Text as="strong" size="kilo" isBold noMargin>
      cancelado
    </Text>
    , pois não foi possível acessar o local da entrega.
  </AlertMessage>
)

export default CancelledAfterInaccessiblePlace
